module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col bg-white space-y-2 lg:space-y-0 lg:flex-row justify-between items-center border border-solid border-gray-200 rounded-lg px-1.5 py-1.5"
  }, [_c('div', {
    staticClass: "flex items-center space-x-1 flex-wrap md:flex-nowrap overflow-x-auto md:overflow-visible"
  }, [(_vm.isDiscussionLive) ? _c('button', {
    staticClass: "border border-solid border-gray-300 hover:bg-gray-100 h-8 text-gray-700 rounded-md px-2 md:px-3.5 py-1",
    attrs: {
      "aria-label": "Fullscreen",
      "title": "Fullscreen"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('toggleFullscreen')
      }
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (!_vm.isSecondScreenOpen && _vm.isDiscussionLive && !_vm.isDiscussionSharingScreen && !_vm.isDiscussionAudioEnabe) ? _c('button', {
    staticClass: "sample border border-solid border-gray-300 hover:bg-gray-100 h-8 text-gray-700 rounded-md px-2 md:px-3.5 py-1",
    attrs: {
      "aria-label": "2nd Screen",
      "title": "2nd Screen"
    },
    on: {
      "click": function($event) {
        return _vm.handleOpenSecondScreen()
      }
    }
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.isDiscussionLive && _vm.isDiscussionAudioEnabe) ? _c('button', {
    staticClass: "sample border border-solid border-gray-300 hover:bg-gray-100 h-8 text-gray-700 rounded-md px-2 md:px-3.5 py-1",
    attrs: {
      "aria-label": _vm.cameraOn ? 'Turn camera off' : 'Turn camera on',
      "title": _vm.cameraOn ? 'Turn camera off' : 'Turn camera on'
    },
    on: {
      "click": function($event) {
        return _vm.handleChangeVideoStatus()
      }
    }
  }, [_c('div', {
    staticClass: "flex items-center space-x-0 md:space-x-2"
  }, [_c('i', {
    class: _vm.cameraOn === true ? 'fa-solid fa-video' : 'fa-solid fa-video-slash text-red-500'
  })])]) : _vm._e(), _vm._v(" "), (_vm.isDiscussionLive && _vm.isDiscussionAudioEnabe) ? _c('button', {
    staticClass: "sample text-center w-8 md:w-12 h-8 rounded-md px-0 md:px-3.5 py-1 hover:bg-gray-100 text-gray-700 border border-solid border-gray-300",
    attrs: {
      "aria-label": _vm.micOn ? 'Mute' : 'Unmute',
      "title": _vm.micOn ? 'Mute' : 'Unmute'
    },
    on: {
      "click": function($event) {
        return _vm.handleChangeMicroStatus()
      }
    }
  }, [_c('div', {
    staticClass: "flex items-center justify-center md:justify-start space-x-0 md:space-x-2"
  }, [_c('i', {
    class: _vm.micOn === false ? 'fa-solid fa-microphone-slash text-red-500' : 'fa-solid fa-microphone ml-1'
  })])]) : _vm._e(), _vm._v(" "), (_vm.isDiscussionLive && _vm.isDiscussionSharingScreen === false && _vm.isDiscussionAudioEnabe) ? _c('button', {
    staticClass: "sample border border-solid border-gray-300 hover:bg-gray-100 h-8 text-gray-700 rounded-md px-2 md:px-3.5 py-1",
    attrs: {
      "aria-label": "Share Screen",
      "title": "Share Screen"
    },
    on: {
      "click": function($event) {
        return _vm.handleStartSharingScreen()
      }
    }
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.isDiscussionLive && _vm.isDiscussionSharingScreen === true && _vm.isDiscussionAudioEnabe) ? _c('button', {
    staticClass: "sample border border-solid border-gray-300 hover:bg-gray-100 h-8 text-gray-700 rounded-md px-2 md:px-3.5 py-1",
    attrs: {
      "aria-label": "Stop Sharing",
      "title": "Stop Sharing"
    },
    on: {
      "click": function($event) {
        return _vm.handleStopSharingScreen()
      }
    }
  }, [_vm._m(3)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "flex items-center flex-wrap md:flex-nowrap"
  }, [_c('button', {
    staticClass: "hover:bg-gray-100 h-8 text-gray-700 rounded-md px-2 md:px-3.5 py-1",
    attrs: {
      "aria-label": "Polls",
      "title": "Polls"
    },
    on: {
      "click": function($event) {
        return _vm.handleOpenPolls()
      }
    }
  }, [_vm._m(4)]), _vm._v(" "), _c('button', {
    staticClass: "hover:bg-gray-100 h-8 text-gray-700 rounded-md px-2 md:px-3.5 py-1 mr-0 md:mr-1",
    attrs: {
      "aria-label": "Questions",
      "title": "Questions"
    },
    on: {
      "click": function($event) {
        return _vm.handleOpenQuestions()
      }
    }
  }, [_vm._m(5)]), _vm._v(" "), (_vm.isDiscussionLive) ? _c('div', {
    staticClass: "mr-0 md:mr-1"
  }, [(_vm.getCurrentDiscussion.teacher_tapped_in_id !== null) ? _c('button', {
    staticClass: "sample hover:bg-gray-100 border border-solid border-gray-300 text-gray-700 h-8 rounded-md px-2 md:px-3.5 py-1",
    attrs: {
      "disabled": !_vm.ImTappedInTeacher,
      "aria-label": "Tap Out",
      "title": "Tap Out"
    },
    on: {
      "click": function($event) {
        return _vm.handleTeacherTapOut()
      }
    }
  }, [_vm._m(6)]) : (_vm.isDiscussionSharingScreen === false) ? _c('button', {
    staticClass: "sample hover:bg-gray-100 border border-solid border-gray-300 text-gray-700 h-8 rounded-md px-2 md:px-3.5 py-1",
    attrs: {
      "aria-label": "Tap In",
      "title": "Tap In"
    },
    on: {
      "click": function($event) {
        return _vm.handleTeacherTapIn()
      }
    }
  }, [_vm._m(7)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.isDiscussionLive) ? _c('button', {
    staticClass: "sample bg-red-500 hover:bg-red-600 h-8 border border-solid border-red-500 text-white rounded-md px-2 md:px-3.5 py-1",
    attrs: {
      "aria-label": "Stop",
      "title": "Stop"
    },
    on: {
      "click": function($event) {
        return _vm.handleEndDiscussion()
      }
    }
  }, [_vm._m(8)]) : _c('button', {
    staticClass: "bg-green-700 hover:bg-green-800 h-8 border border-solid border-green-700 hover:border-green-800 text-white rounded-md px-2 md:px-3.5 py-1",
    attrs: {
      "aria-label": "Start",
      "title": "Start"
    },
    on: {
      "click": function($event) {
        return _vm.handleRestartLiveDiscussion()
      }
    }
  }, [_vm._m(9)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-0 md:space-x-2"
  }, [_c('i', {
    staticClass: "fa-solid fa-expand"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden md:inline"
  }, [_vm._v("Fullscreen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-0 md:space-x-2"
  }, [_c('img', {
    staticClass: "w-4 h-4",
    attrs: {
      "src": "/static/live_discussion/2nd_screen.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden md:inline"
  }, [_vm._v("2nd Screen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-0 md:space-x-2"
  }, [_c('img', {
    staticStyle: {
      "height": "17px",
      "width": "17px"
    },
    attrs: {
      "src": "/static/chrome-cast.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden md:inline"
  }, [_vm._v("Share Screen")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-0 md:space-x-2"
  }, [_c('img', {
    staticStyle: {
      "height": "17px",
      "width": "17px"
    },
    attrs: {
      "src": "/static/stop-screen.svg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden md:inline"
  }, [_vm._v("Stop Sharing")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-0 md:space-x-2"
  }, [_c('i', {
    staticClass: "fa-solid fa-chart-pie"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden md:inline"
  }, [_vm._v("Polls")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-0 md:space-x-2"
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-question"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden md:inline"
  }, [_vm._v("Questions")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-0 md:space-x-2"
  }, [_c('i', {
    staticClass: "fa-solid fa-arrow-up-from-bracket rotate-90"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden md:inline"
  }, [_vm._v("Tap Out")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-0 md:space-x-2"
  }, [_c('i', {
    staticClass: "fa-solid fa-arrow-up-from-bracket rotate-90"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden md:inline"
  }, [_vm._v("Tap In")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-0 md:space-x-2"
  }, [_c('i', {
    staticClass: "fa-solid fa-stop"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden md:inline"
  }, [_vm._v("Stop")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex items-center space-x-0 md:space-x-2"
  }, [_c('i', {
    staticClass: "fa-solid fa-play -mt-0.5"
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden md:inline",
    staticStyle: {
      "margin-top": "-1px"
    }
  }, [_vm._v("Start")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-c63d5416!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/components/LDDiscussionTeacherBar.vue
// module id = 1759
// module chunks = 61